import "./foodCategory.css";
import React, {useContext, useEffect, useRef, useState} from "react";
import foods from "../../assets/foods.json";
import TextsContext from "../../TextsContent";
import {useNavigate, useParams} from "react-router-dom";
import RoutesToPages from "../../assets/RoutesToPages/Routes";

const FoodCategory = () => {
  const {category} = useParams();
  console.log(foods.categories);
  const foodsArr = foods.categories;
  const [selectedCategory, setSelectedCategory] = useState(null);

  const navigate = useNavigate();
  const texts = useContext(TextsContext);
  // const userProfileData = JSON.parse(localStorage.getItem('userProfileData'));
  const userID = localStorage.getItem("userHash") ?? null;
  const userProfileData =
    JSON.parse(localStorage.getItem(userID))?.userProfileData ?? null;
  const timerFadeIn = useRef(null);
  const foodCategoryRef = useRef(null);


  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});

    if (foodCategoryRef.current) {
      foodCategoryRef.current.classList.add('food-category-fade-in');
    }

    timerFadeIn.current = setTimeout(() => {
      foodCategoryRef.current.classList.remove('food-category-fade-in');
    }, 350);

    return () => {
      clearTimeout(timerFadeIn.current)
    }
  }, []);


  const handleCategoryHome = (route, identifier) => {
    setSelectedCategory(identifier);
    console.log(identifier);
    navigate(route, {
      state: {activeCategory: identifier},
    });
  };


  return (
    <>
      <div ref={foodCategoryRef}
           className="main-container food-category-main">
        <div className="outer-content">
          <img
            loading="lazy"
            className="main-logo"
            src={require("./img/food_image.png")}
            alt="logo"
          ></img>
          <p className="main-text">{texts.food}</p>
          <div className="site-title">
            <img
              className="main-logo"
              loading="lazy"
              src={require("./img/logo_text.png")}
            ></img>
          </div>
        </div>

        <div className="inner-content food-category inner-content-food-category">
          <div className="workout-navigation">
            <img
              className="workout-navigation__arrow"
              onClick={() => navigate(-1)}
              src={require("../../assets/img/back_arrow.svg").default}
              width="24"
              height="24"
              alt="image arrow left"
            ></img>
          </div>

          {foodsArr.map((item) => {
            return (
              <div
                key={item.name}
                onClick={() =>
                  handleCategoryHome(
                    RoutesToPages.foods(item.name.toLowerCase()),
                    item.name
                  )
                }
                className="menu-item menu-item--food"
              >
                <div className="menu-item__icon menu-item__icon--food-category">
                  <img
                    loading="lazy"
                    className="menu-item__image"
                    src={require(`${item.image}`)}
                    alt=" icon"
                  />
                </div>
                <div className="menu-text__wrapper">
                  <h2 className="menu-item__title menu-item__title--food-category">{item.name}</h2>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default FoodCategory;
